// composants/Hero.jsx
export default function Hero() {
  return (
    <div className="relative bg-gradient-to-r from-orange-600 to-amber-700 text-white">
      <div className="absolute inset-0 bg-black/20" />
      <div className="relative mx-auto px-4 py-12 sm:py-16 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
          Mode & Élégance
        </h1>
        <p className="mt-4 max-w-xl text-lg text-amber-50">
          Découvrez les dernières tendances, livraison gratuite dès 50 000 FCFA.
        </p>
        <button
          onClick={() => document.getElementById('produits')?.scrollIntoView({ behavior: 'smooth' })}
          className="mt-8 rounded-full bg-white px-6 py-3 font-semibold text-orange-600 shadow-md hover:bg-amber-50"
        >
          Voir les produits
        </button>
      </div>
    </div>
  );
}